// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__3UI7T","text":"LimitedAccessBanner_text__384bF","button":"LimitedAccessBanner_button__2izww"};